var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store, Actions, ofActionDispatched, Select } from '@ngxs/store';
import { SignUp, SignUpSuccess, SignUpFailure, LoginWithGoogle, CheckSession } from '../../state/auth/auth.actions';
import { SignUpModel } from '../../models/sign-up.model';
import { plainToClass } from 'class-transformer';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AuthState } from '../../state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../../auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleLoginModel } from '../../models/google-login.model';
var SignUpPageComponent = /** @class */ (function () {
    function SignUpPageComponent(formBuilder, store, actions, snackbar, authService, sanitizer, activatedRoute) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.actions = actions;
        this.snackbar = snackbar;
        this.authService = authService;
        this.sanitizer = sanitizer;
        this.activatedRoute = activatedRoute;
        this.ngUnsubscribe = new Subject();
        this.groupConfig = this.authService.getGroupConfigFromRoute(this.activatedRoute.snapshot);
        this.form = this.formBuilder.group({
            'firstName': ['', Validators.required],
            'lastName': ['', Validators.required],
            'email': ['', Validators.email],
            'password': ['', [Validators.minLength(8), Validators.maxLength(255)]],
            'groupCode': [this.groupConfig.groupCode]
        });
    }
    Object.defineProperty(SignUpPageComponent.prototype, "firstName", {
        get: function () { return this.form.get('firstName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpPageComponent.prototype, "lastName", {
        get: function () { return this.form.get('lastName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpPageComponent.prototype, "email", {
        get: function () { return this.form.get('email'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpPageComponent.prototype, "password", {
        get: function () { return this.form.get('password'); },
        enumerable: true,
        configurable: true
    });
    SignUpPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.actions
            .pipe(ofActionDispatched(SignUpSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function () { return _this.handleSignUpSuccess(); });
        this.actions
            .pipe(ofActionDispatched(SignUpFailure), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleSignUpFailure(action.error);
        });
        // this.actions
        //   .pipe(
        //     ofActionDispatched(LoginFailure),
        //     takeUntil(this.ngUnsubscribe)
        //   )
        //   .subscribe((action: LoginFailure) => {
        //     this.handleSignUpFailure(action.error);
        //   });
        // this.actions
        //   .pipe(
        //     ofActionDispatched(LoginSuccess),
        //     takeUntil(this.ngUnsubscribe)
        //   )
        //   .subscribe((action: LoginSuccess) => this.handleSignUpSuccess());
    };
    SignUpPageComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SignUpPageComponent.prototype.handleGoogleClick = function () {
        var _this = this;
        this.authService.authenticateWithGoogle()
            .then(function (value) {
            // Group code values
            var login = __assign({}, new GoogleLoginModel(value.idToken), _this.groupConfig);
            login.groupCode = _this.form.get('groupCode').value;
            _this.store.dispatch(new LoginWithGoogle(login));
        })
            .catch(function (error) {
            if (error instanceof String) {
            }
            else if (error instanceof HttpErrorResponse) {
                _this.handleSignUpFailure(error);
            }
        });
    };
    SignUpPageComponent.prototype.handleFormSubmit = function () {
        this.errorMessage = '';
        if (this.form.valid) {
            this.signup();
        }
    };
    SignUpPageComponent.prototype.handleSignUpSuccess = function () {
        this.snackbar.open('Successfully created account');
        this.store.dispatch(new CheckSession());
    };
    SignUpPageComponent.prototype.handleSignUpFailure = function (error) {
        var message = error.error.error.message;
        this.errorMessage = this.sanitizer.bypassSecurityTrustHtml(message);
    };
    SignUpPageComponent.prototype.signup = function () {
        // Get form and group values
        var signUp = plainToClass(SignUpModel, __assign({}, this.form.value, this.groupConfig));
        signUp.groupCode = this.form.get('groupCode').value;
        this.store.dispatch(new SignUp(signUp));
    };
    __decorate([
        Select(AuthState.getLoading),
        __metadata("design:type", Observable)
    ], SignUpPageComponent.prototype, "loading$", void 0);
    return SignUpPageComponent;
}());
export { SignUpPageComponent };
